import { render, staticRenderFns } from "./InvoiceSummary.vue?vue&type=template&id=950aa254&scoped=true&"
import script from "./InvoiceSummary.vue?vue&type=script&lang=js&"
export * from "./InvoiceSummary.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSummary.vue?vue&type=style&index=0&id=950aa254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950aa254",
  null
  
)

export default component.exports